<template>
  <v-bottom-sheet
      v-model="sheet"
      scrollable
      persistent
      no-click-animation
      :overlay-opacity="0.7"
      content-class="bottom-sheet"
  >
    <v-card class="pb-2">
      <v-card-title>
        <div class="fs-14">
          <span v-if="dates" style="letter-spacing: -1px">
            {{ getTextDate(startDate) }} ~ {{ getTextDate(endDate) }} &nbsp;&#8226; {{ availStopDay }}일
          </span>
          <span v-else class="primary--text">
            중지 시작 날짜를 선택해주세요.
          </span>
        </div>
        <v-spacer />
        <v-btn icon @click="closeSheet">
          <Close/>
        </v-btn>
      </v-card-title>
      <v-card-text v-if="sheet" class="border-none px-0 py-0">
        <vc-calendar
            class="border-none"
            color="purple"
            title-position="left"
            :attributes="[{
                highlight: {
                  color: 'purple',
                  start: { fillMode: 'solid' },
                  base: { fillMode: 'light' },
                  end: { fillMode: 'solid' },
                },
                dates: dates
            },
            { key: 'today',
              dot: true,
              dates: new Date()
            }]"
            :rows="rows"
            transition="slide-v"
            is-expanded
            :available-dates="availableDates"
            disable-page-swipe
            @dayclick="onDayClick"
        >
          <template #header="props">
            <v-card-title class="py-1 text-h6 font-weight-bold">
              {{ props.yearLabel }}년 {{ props.monthLabel }}
            </v-card-title>
          </template>
        </vc-calendar>
      </v-card-text>
      <hr class="v-divider theme--light mb-2">
      <v-card-actions>
        <div class="btn-group">
          <v-btn depressed elevation="0" color="cancel" @click="closeSheet">취소</v-btn>
          <v-btn depressed elevation="0" color="primary" @click.prevent="onSubmit" :disabled="!dates">확인</v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-bottom-sheet>
</template>

<script>
import Vue from 'vue';
import Util from '@/utils/utils'
import VCalendar from 'v-calendar';
import Close from "@/components/icons/Close.vue";

Vue.use(VCalendar, {
  componentPrefix: 'vc'
});
export default {
  name: 'PubTest',
  components: {Close},
  props: {
    availStopDay: {
      type: [Number, String],
      default: 7 // 중지 기간
    },
    ticketEndDate: {
      type: String,
      default: '2023-11-30' // 임시 티켓 종료일
    },
    selectedStartDate: {
      type: String,
      default: '2023-11-30' // 임시 예약 시작일
    }
  },
  data: () => ({
    sheet: false,
    dates: null
  }),
  computed: {
    span () {
      return Number(this.availStopDay)
    },
    // 사용자가 확인 가능한 날짜 전체 펼침
    rows () {
      let start = Util.Date.toFormatDate(new Date(), 'YYYY-MM-01')
      let end = Util.Date.toFormatDate(this.ticketEndDate, 'YYYY-MM-01')
      return Util.Date.diff(end, start, 'month')
    },
    startDate () {
      if (this.dates) return this.dates.start
      return null
    },
    endDate () {
      if (this.dates) return Util.Date.add(this.startDate, 6, 'day', 'YYYY-MM-DD')
      return null
    },
    availableDates () {
      let start = Util.Date.add(new Date(), 1, 'day', 'YYYY-MM-DD')
      let end = Util.Date.subtract(this.ticketEndDate, 6, 'day', 'YYYY-MM-DD').fromDate
      return {
        start: start,
        end: end
      }
    }
  },
  watch: {
    sheet (nV) {
      if (nV && this.selectedStartDate) {
        this.dates = { start: this.selectedStartDate, span: this.span }
      } else {
        this.dates = null
      }
    }
  },
  created () {
  },
  methods: {
    getTextDate (value) {
      if (value) return Util.Date.toFormatDate(value,  'YYYY년 M월 D일 (dd)')
    },
    openSheet () {
      this.sheet = true
    },
    closeSheet () {
      this.sheet = false
    },
    onDayClick (day) {
      if (!day.isDisabled) {
        this.dates = { start: day.id, span: this.span }
      }
    },
    onSubmit () {
      this.$emit('selectValue', {start: this.startDate, end: this.endDate})
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .vc-arrows-container {
    display: none !important;
  }
  .in-next-month.is-not-in-month {
    display: none !important;
  }
}
</style>
